// export { default as searchList } from './searchList/searchList.vue';
export const searchList = (r) => require.ensure([], () => r(require("./searchList/searchList.vue")), "searchList");
